module.exports = __webpack_public_path__ + "img/zephyrus.f7f88624.jpg";